import { colors } from 'constants/colorsBase';
import styled from 'styled-components';

export const MemberHeaderTableWrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid ${colors.lineColor};
  width: 95rem;
  padding-bottom: 0.313rem;
  font-size: 1.5rem;
  margin-top: 1.5rem;
`;
export const DayWrapperHeader = styled.div`
  width: 25rem;
`;
export const AttendanceWrapper = styled.div`
  width: 66rem;
  padding-left: 2.5rem;
`;
